<template>
  <div class="kuaishouapp-wrap">
    <div class="card-header">快手应用</div>
    <div class="newgroup-wrap" style="padding-top: 20px">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <li class="form-item">
            <span class="form-label" style="padding-top: 8px">应用：</span>
            <div class="form-value">
              <el-form-item prop="selectPro">
                <el-select
                  style="width: 300px"
                  v-model="formData.selectPro"
                  placeholder="请选择"
                  popper-class="pro-select"
                  @change="(data) => changeApp(data, true)"
                >
                  <el-option
                    v-for="item of proList"
                    :key="item.app_type"
                    :value="item.app_id"
                    :label="item.app_name + '(' + item.app_type + ')'"
                  >
                    <div class="seitem-wrap">
                      <div class="img-wrap">
                        <img class="app-img" :src="item.icon_url" />
                      </div>
                      <div class="seitem-content">
                        <span class="app-detail">{{ item.app_name }}</span>
                        <span class="app-detail">{{ item.app_type }}</span>
                      </div>
                      <svg-icon
                        :iconClass="
                          item.platform === 'ANDROID'
                            ? 'android'
                            : item.platform === 'IOS'
                            ? 'apple'
                            : ''
                        "
                        className="os-icon"
                      ></svg-icon>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">转化跟踪：</span>
            <div class="form-value">
              <el-radio-group
                v-model="formData.convert"
                @change="changeConvert"
              >
                <el-radio label="none">不限</el-radio>
                <el-radio label="api">应用-API</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-if="formData.convert === 'api'">
            <span class="form-label" style="padding-top: 0px"></span>
            <div class="form-value">
              <el-form-item
                prop="convertApp"
                style="margin-bottom: 0px"
                class="select-count-formItem"
              >
                <el-select
                  v-model="formData.convertApp"
                  placeholder="请选择"
                  style="width: 300px"
                  popper-class="count-select"
                  @change="checkConverApp"
                >
                  <el-option
                    v-for="item of converProList"
                    :key="item.convert_id"
                    :label="item.convert_name + '(' + item.convert_id + ')'"
                    :value="item.convert_id"
                  >
                    <div class="count-option">
                      <span class="count-item">{{ item.convert_name }}</span>
                      <span class="count-item">ID：{{ item.convert_id }}</span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { kuaishouAppList } from "@/api/promotion-kuaishou.js";
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  name: "kuaishouapp",
  components: {
    SvgIcon,
  },
  data() {
    return {
      formData: {
        selectPro: null,
        convert: "none",
        convertApp: null,
      },
      rules: {
        selectPro: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "快手应用不可为空",
          },
        ],
        convertApp: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请选择应用-API",
          },
        ],
      },
      proList: [],
      converProList: [],
    };
  },
  methods: {
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.saveInStore();
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    saveInStore() {
      if (this.formData.selectPro) {
        let storeData = {
          checkType: this.formData.convert,
          app_id: this.formData.selectPro,
          label:
            this.proList.length > 0
              ? this.proList.find(
                  (item) => item.app_id === this.formData.selectPro
                ).app_name
              : null,
          subLabel:
            this.proList.length > 0
              ? this.proList.find(
                  (item) => item.app_id === this.formData.selectPro
                ).app_type
              : null,
        };
        if (this.formData.convert === "api" && this.formData.convertApp) {
          storeData.convert_id = this.formData.convertApp;
          let curConverObj = this.converProList.find(
            (item) => item.convert_id === this.formData.convertApp
          );
          storeData.convert_name = curConverObj
            ? curConverObj.convert_name
            : "-";
        }
        this.$store.commit("set_promote_object_k", storeData);
      }
    },
    //保存应用数据到store
    changeSelectPro(appId) {
      let item = this.proList.find((item) => item.app_id === appId);
      if (item) {
        let copyData = JSON.parse(JSON.stringify(item));
        delete copyData.converts;
        this.$store.commit("setcheckedApp_k", copyData);
      } else {
        this.$store.commit("setcheckedApp_k", {});
      }
    },
    searchKuaishouApp(advertiserId) {
      kuaishouAppList({
        advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          if (res.convertExtras.length === 0) {
            this.proList = [];
            this.formData.selectPro = null;
            this.changeSelectPro(null);
            this.changeApp(null, false);
          } else {
            this.proList = res.convertExtras;
            // this.formData.selectPro = res.convertExtras[0].app_id;
            // 保存到store
            // this.changeSelectPro(this.formData.selectPro);
            this.changeApp(this.formData.selectPro, false);
          }
        }
      });
    },
    changeApp(data, clearConver) {
      if (data) {
        this.changeSelectPro(data);
        this.converProList = this.proList.find(
          (item) => item.app_id === data
        ).converts;
      } else {
        this.converProList = [];
      }
      //初始查询不清空
      if (clearConver) {
        this.formData.convertApp = null;
      }
    },
    changeConvert(value) {
      if (value === "none") {
        this.$store.commit("setclickUrl_k", "");
      }
      this.saveInStore();
    },
    checkConverApp(data) {
      if (data) {
        let checkedConvert = this.converProList.find(
          (item) => item.convert_id === data
        );
        if (checkedConvert) {
          this.$store.commit("setclickUrl_k", checkedConvert.click_url);
        }
      } else {
        this.$store.commit("setclickUrl_k", "");
      }
      this.saveInStore();
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionKuaishou.adCount,
      promote_object: (state) =>
        state.PromotionKuaishou.draft_adset.promote_object,
    }),
  },
  watch: {
    adCount(value) {
      if (value) {
        this.searchKuaishouApp(value.advertiserId);
      }
    },
    promote_object(value) {
      if (value) {
        this.formData.selectPro = value.app_id;
        this.formData.convert = value.checkType;
        if (value.convert_id) {
          this.formData.convertApp = value.convert_id;
        } else {
          this.formData.convertApp = null;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.kuaishouapp-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .btn-group {
    margin-top: 16px;
    .def-btn {
      color: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .newgroup-wrap {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        /deep/ .el-form-item {
          margin-bottom: 6px;
        }
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 90px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 6px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-form-item {
            margin: 0px;
          }
          /deep/ .el-form-item__content {
            line-height: 32px;
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          .pro-select {
            .el-select-dropdown__item {
              height: 45px;
              line-height: 45px;
            }
            .seitem-wrap {
              height: 100%;
              display: flex;
              align-items: center;
              padding: 0px;
              box-sizing: border-box;
              .img-wrap {
                width: 30px;
                height: 30px;
                margin-right: 10px;
                .app-img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .seitem-content {
                font-size: 12px;
                .app-detail {
                  display: block;
                  line-height: 16px;
                }
              }
              .os-icon {
                margin: 0 0px 0 auto;
                font-size: 18px;
              }
            }
          }
          .count-select {
            .el-select-dropdown__item {
              height: 45px;
              line-height: 45px;
            }
            .count-option {
              font-size: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              height: 100%;
              .count-item {
                display: block;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>